import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
// import "amfe-flexible";
import "@/components/time.scss";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
// mian.js首先引入element-ui中文包
import zhLocale from "element-ui/lib/locale/lang/zh-CN";

Vue.use(ElementUI, {
  size: "small",
  locale: {
    el: {
      // 整体覆盖
      ...zhLocale.el,
      pagination: {
        pagesize: "页",
        total: `共 {total} 条`,
        goto: "前往第",
        pageClassifier: "页",
      },
    },
  },
});

Vue.use(ElementUI);
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
